import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap";
import styled from "styled-components";

class CustomBreadcrumbs extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
        <Row>
          <Col xs="12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-3">
              <div className="page-title-left">
                <Breadcrumb listClassName="m-0">
                  {this.props.breadcrumbItem.map((i, key) => (
                    <BreadcrumbItem key={key} active={false}>
                      {i.link ? (
                        <StyledLink
                          to={{
                            pathname: i.link,
                            state: i.state,
                          }}
                        >
                          {i.title}
                        </StyledLink>
                      ) : (
                        <CustomSpan
                          style={{ color: i.active && "rgb(85,110,230)" }}
                        >
                          {i.title}
                        </CustomSpan>
                      )}
                    </BreadcrumbItem>
                  ))}
                </Breadcrumb>
              </div>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const CustomSpan = styled.span`
  color: #74788d !important;
`;

const StyledLink = styled(Link)`
  transition-duration: 0.5s;
  color: #74788d !important;

  &:hover {
    color: rgb(85, 110, 230) !important;
    transition-duration: 0.5s;
  }
`;

CustomBreadcrumbs.propTypes = {
  breadcrumbItem: PropTypes.any,
  link: PropTypes.any,
};

export default CustomBreadcrumbs;
